//  item/index.js
import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { Edit } from './edit';
import Save from './save';

registerBlockType('za/timeline-item', {
	apiVersion: 3,
	title: __('Timeline Item', 'timeline-full-widget'),
	description: __('Timeline Item Description', 'timeline-full-widget'),
	icon: 'universal-access',
	parent: ['za/timeline-full-widget'],
	supports: {
		html: false,
		reusable: false,
		spacing: {
			margin: true,
		},
		color: {
			text: true,
			background: true,
			link: true,
		},
		typography: {
			fontSize: true,
			lineHeight: true,
		},
	},
	attributes: {
		title: {
			type: 'string',
			source: 'html',
			selector: '.tl-title',
		},
		titleInlineStyle: {
			type: 'string',
			source: 'attribute',
			selector: '.tl-title',
			attribute: 'style',
			default: '',
		},
		titleTag: {
			type: 'string',
			default: 'h3',
		},
		titleColor: {
			type: 'string',
			default: '',
		},
		titleFontSize: {
			type: 'object',
			default: {
				desktop: 22,
				tablet: null,
				mobile: null,
			},
		},
		titleFontUnit: {
			type: 'string',
			default: 'px',
		},
		titleFontWeight: {
			type: 'string',
			default: '',
		},
		titleAlign: {
			type: 'string',
			default: 'left',
		},
		titleFontFamily: {
			type: 'string',
			default: '',
		},
		titleLineHeight: {
			type: 'string',
			default: '1.5',
		},
		titleLetterSpacing: {
			type: 'string',
			default: '',
		},
		titleMarginTop: {
			type: 'string',
			default: '10px',
		},
		titleMarginBottom: {
			type: 'string',
			default: '0px',
		},

		descriptionColor: {
			type: 'string',
			default: '',
		},
		itemBackgroundColor: {
			type: 'string',
			default: '',
		},
		linkUrl: {
			type: 'string',
			default: '',
		},
		linkTarget: {
			type: 'string',
			default: '',
		},
		rel: {
			type: 'string',
			default: '',
		},
		mediaLinkUrl: {
			type: 'string',
			default: '',
		},
		mediaLinkTarget: {
			type: 'string',
			default: '',
		},
		mediaLinkRel: {
			type: 'string',
			default: '',
		},
		isMediaWrapToLink: {
			type: 'boolean',
			default: false,
		},
		position: {
			type: 'string',
			default: 'timeline-left',
		},
		onTheOneSide: {
			type: 'boolean',
			default: false,
		},
		horizontalContentLayout: {
			type: 'boolean',
			default: false,
		},
		reverseMediaContent: {
			type: 'boolean',
			default: false,
		},
		showMedia: {
			type: 'boolean',
			default: true,
		},
		mediaUrl: { type: 'string', default: '' },
		videoPoster: {
			type: 'string',
			source: 'attribute',
			selector: '.timeline_pic video',
			attribute: 'poster',
			default: '',
		},
		imageAlt: {
			type: 'string',
			source: 'attribute',
			selector: '.timeline_pic img',
			attribute: 'alt',
			default: '',
		},
		mediaWidth: {
			type: 'string',
			default: '',
		},
		mediaId: {
			type: 'number',
		},
		mediaType: { type: 'string', default: '' },
		mediaMime: { type: 'string', default: '' },
		showOtherSide: {
			type: 'boolean',
			default: true,
		},
		otherSiteTitle: {
			type: 'string',
			selector: '.timeline-side p',
			default: '',
		},
		sideTextAlign: {
			type: 'string',
			default: 'left',
		},
		showMarker: {
			type: 'boolean',
			default: true,
		},
		markerUnique: {
			type: 'boolean',
			default: false,
		},
		markerUrl: { type: 'string', default: '' },
		markerId: { type: 'number' },
		markerAlt: { type: 'string', default: '' },
	},
	edit: Edit,
	save: Save,
});
